/**
 * @file 画像削除
 */
'use strict';

/**
 * @classname DeleteImage
 * @classdesc 画像削除
 */
export default class DeleteImage {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('DeleteImage.constructor');
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};


	/**
	 * 画像削除ボタンクリック
	 *
	 * @memberof DeleteImage
	 * @param {event) e - イベント
	 * @return {undefined}
	 */
	onClick() {
		console.log('DeleteImage.onClick');
		this._$e.closest('.form-group').find('.input-image').val('');
		this._$e.closest('.upload-image-wrap').remove();
	};
}
